import React from "react";
import { AreaChart, Area, ResponsiveContainer, Tooltip } from "recharts";
import { FREIGHT_TREND } from "./constants";

// Indicative only — static sample data
export default function FreightTrendCard() {
    return (
        <div className="bg-[#111827] border border-[#1F2937] rounded-xl p-4 flex-1">
            <div className="flex items-center justify-between mb-1">
                <p className="text-sm font-bold text-white">Freight Spend Trend</p>
                <span className="text-[10px] text-slate-600 italic">indicative</span>
            </div>
            <p className="text-[11px] text-slate-500 mb-2">This Month (A$)</p>
            <ResponsiveContainer width="100%" height={100}>
                <AreaChart data={FREIGHT_TREND} margin={{top:4,right:4,bottom:0,left:0}}>
                    <defs>
                        <linearGradient id="freight" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%"  stopColor="#8B5CF6" stopOpacity={0.4}/>
                            <stop offset="95%" stopColor="#8B5CF6" stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <Tooltip
                        contentStyle={{background:"#1F2937",border:"none",borderRadius:8,fontSize:11}}
                        labelStyle={{color:"#9CA3AF"}} itemStyle={{color:"#8B5CF6"}}
                        formatter={v => [`A$${v.toLocaleString()}`,"Spend"]}
                    />
                    <Area type="monotone" dataKey="v" stroke="#8B5CF6" strokeWidth={2}
                        fill="url(#freight)" dot={false} isAnimationActive={false}/>
                </AreaChart>
            </ResponsiveContainer>
            <div className="flex justify-between text-[10px] text-slate-600 mt-1 px-1">
                {FREIGHT_TREND.map(d => <span key={d.d}>{d.d}</span>)}
            </div>
        </div>
    );
}
